import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import ViewTitle from '../../common/view-title';
import Loader from '../../common/loader';
import NotFound from '../../common/not-found';

import CarrierMenu from './carrier-menu';
import CarrierIndex from './carrier-index';
import CarrierDetail from './carrier-detail';

import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    }
}));

const Carrier = () => {

    const classes = useStyles();
    const { pathname } = useLocation();
    const { path } = useRouteMatch();
    const [state, setState] = useState({
        loading: true,
        permissions: {}
    });

    useEffect(() => {
        const validatePermissions = () => {
            const permissions = helpers.getPermissions(pathname);
            setState(prev => ({ ...prev, permissions, loading: false }));
        }

        validatePermissions();
    }, []);

    if (state.loading) return <Loader />;
    if (!state.permissions?.read_attr) return <NotFound />;

    return (
        <div className={classes.root}>
            <ViewTitle sedeFlag title='Carrier' />

            <Switch>
                <Route exact strict path={path}><CarrierMenu permissions={state.permissions} /></Route>
                {/* <Route exact strict path={`${path}/report`}><TicketSaleReport permissions={state.permissions} /></Route> */}
                <Route exact strict path={`${path}/index`}><CarrierIndex permissions={state.permissions} /></Route>
                <Route exact strict path={`${path}/:id`}><CarrierDetail permissions={state.permissions} /></Route>
                <Route path={`${path}/*`}><NotFound /></Route>
            </Switch>
        </div>
    );
}

export default Carrier;